import { parseISO, differenceInHours } from 'date-fns';
import { TARGETED_OFFER_APPLIED } from 'contexts/CruiseSearchContext/constants';

export function getLastAppliedHours() {
  const lastPromoApplied = localStorage.getItem(TARGETED_OFFER_APPLIED.key)
    ? JSON.parse(localStorage.getItem(TARGETED_OFFER_APPLIED.key))
    : {};

  let lastAppliedHours = undefined;
  if (lastPromoApplied.lastApplied) {
    lastAppliedHours = differenceInHours(
      parseISO(new Date().toJSON()),
      parseISO(lastPromoApplied.lastApplied),
    );
  }

  return { lastAppliedHours };
}
